import type { ReactNode } from 'react';
import { useUi } from '../store/ui';
import { S } from '../strings';
import { Icon } from './icons';

/**
 * The top of every screen off the Play menu: Back on the left, the screen's name in the middle (when
 * its first board doesn't already carry it in a band) and an optional slot on the right. One look
 * for every screen instead of a Back button on its own.
 */
export function ScreenTop({ title, titleId, end }: { title?: string; titleId?: string; end?: ReactNode }) {
  const set = useUi((s) => s.set);
  return (
    <header className="screen-top">
      <button
        type="button"
        className="wh-btn wh-btn--sm screen-top__back"
        onClick={() => set({ screen: 'menu', notice: null })}
      >
        <Icon name="back" size={16} />
        {S.menu.back}
      </button>
      {title ? (
        <h1 id={titleId} className="screen-top__title">
          {title}
        </h1>
      ) : (
        <span className="screen-top__title" />
      )}
      <span className="screen-top__end">{end}</span>
    </header>
  );
}
